import { APP_INITIALIZER, LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';

import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RouteReuseStrategy } from '@angular/router';
import { AbcCoreModule } from '@barthauer/abc/core';
import { AbcConfigService, AbcCoreConfigurationModule } from '@barthauer/abc/core/configuration';
import {
  CacheService,
  DataService as CoreDataService,
  ObjectSpaceService,
  PersistenceService,
  QueryService,
} from '@barthauer/abc/core/data';
import { UsersModule } from '@barthauer/abc/management/users';
import {
  AbcCoreContainerService,
  AbcPopupComponent,
  AbcTabPanelComponent,
  AbcTextBoxComponent,
  AbcToastComponent,
  AbcUiComponentsModule,
  _AbcButtonComponent,
  _AbcContextMenuComponent,
  _AbcDrawerComponent,
  _AbcSelectBoxComponent,
  _AbcToolbarComponent,
  _AbcTooltipComponent,
  _AbcTreeComponent,
} from '@barthauer/abc/ui-components';
import { AbcCoreAuthenticationModule } from '@barthauer/basys/core/authentication';
import { CustomArenaModule } from '@barthauer/custom/arena';
import {
  DxButtonModule,
  DxContextMenuModule,
  DxDrawerModule,
  DxFormModule,
  DxLoadIndicatorModule,
  DxPopupModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxSwitchModule,
  DxTextBoxModule,
  DxToastModule,
  DxToolbarModule,
  DxTooltipModule,
  DxTreeViewModule,
} from 'devextreme-angular';
import { CoreService } from 'libs/abc/core/core.service';
import { DataService } from '../app/core/services/data.service';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { CompaniesComponent } from './core/companies/companies.component';
import { CoreComponent } from './core/core.component';
import { FavoriteListModule } from './core/favorite-list/favorite-list.module';
import { LoginComponent } from './core/login/login.component';
import { NotificationService } from './core/services/notification.service';
import { ScreenService } from './core/services/screen.service';
import { CompaniesModule } from './core/shared/companies/companies.module';
import { SupportPopupComponent } from './core/shared/support-mail-popup/support-mail-popup.component';
import { UbtLoaderComponent } from './core/shared/ubt-loader/ubt-loader.component';
import { CustomRouteReuseStrategy } from './CustomRouteReuseStrategy';
import { ProfileSelectionComponent } from './core/shared/select-profil/select-profil.component';
import { LandingPageComponent } from './core/shared/landing-page/landing-page.component';
import { NotificationPopupComponent } from './core/shared/notification/notification-popup/notification-popup.component';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import { LanguageService } from './core/services/language.service';
import {  provideAnimations } from '@angular/platform-browser/animations';
registerLocaleData(localeDe);
registerLocaleData(localeEn);
@NgModule({
  declarations: [
    AppComponent,
    CoreComponent,
    CompaniesComponent,
    LandingPageComponent,
    LoginComponent,
    ProfileSelectionComponent,
  ],
  imports: [
    AppRoutingModule,
   
    CompaniesModule,
    BrowserModule,
    CommonModule,
    AbcCoreConfigurationModule,
    DxTooltipModule,
    DxToolbarModule,
    DxDrawerModule,
    DxTreeViewModule,
    DxContextMenuModule,
    DxSwitchModule,
    DxScrollViewModule,
    MatIconModule,
    DxPopupModule,
    DxButtonModule,
    DxSelectBoxModule,
    AbcToastComponent,
    FavoriteListModule,
    _AbcDrawerComponent,
    _AbcToolbarComponent,
    AbcPopupComponent,
    _AbcSelectBoxComponent,
    _AbcButtonComponent,
    _AbcTooltipComponent,
    _AbcTreeComponent,
    _AbcContextMenuComponent,
    AbcCoreAuthenticationModule,
    DxFormModule,
    ReactiveFormsModule,
    DxLoadIndicatorModule,
    DxToastModule,
    DxTextBoxModule,
    CustomArenaModule,
    UbtLoaderComponent,
    UsersModule,
    DxContextMenuModule,
    AbcUiComponentsModule,
    AbcCoreModule,
    AbcTextBoxComponent,
    SupportPopupComponent,
    NotificationPopupComponent,
    AbcPopupComponent,
    AbcTabPanelComponent,
  ],
  providers: [
    DatePipe,
    ScreenService,
    AbcConfigService,
    DataService,
    NotificationService,
    CoreDataService,
    CacheService,
    PersistenceService,
    CoreService,
    ObjectSpaceService,
    QueryService,
    AbcCoreContainerService,
    provideAnimations(),
   
    {
      provide: 'ObjectSpaceMaster',
      useValue: 'KAOS.Master',
    },

    {
      provide: LOCALE_ID,
      useFactory: () => {
        const lang = sessionStorage.getItem('currentUserLanguage');
        return lang === 'de' ? 'de-DE' : 'en-US';
      },
    },
    provideAppInitializer(() => {
      const abcConfigService = inject(AbcConfigService);
      const languageService = inject(LanguageService);

      return (async () => {
        const configInitializer = ConfigurationFactory(abcConfigService);
        await configInitializer();
        await languageService.init();
      })();
    }),
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    CacheService.isCachingDisabled = true;
  }
}
export function initLanguage(languageService: LanguageService) {
  return () => languageService.init();
}
export function ConfigurationFactory(globalConfig: AbcConfigService) {
  return () => {
    return new Promise((resolve) => {
      globalConfig.loadConfig(environment.appConfigUrl).then((result) => {
        resolve(result);
      });
    });
  };
}
